const moduleName = 'fbShare';

export function fbShare() {

    Array.from(document.querySelectorAll('.js-fb-share')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const button = self;
        const url = button.dataset.url;

        button.addEventListener('click', () => {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, 'newwindow', 'width=650,height=450');
        });
    });

}